import dayjs from "dayjs";

// Calcule l'échéance d'un contrat/avenant à partir de la date d'effet et d'une durée en MOIS.
// Règle : l'échéance est la veille de l'anniversaire, en fin de journée (23:59:59).
//   ex. effet 01/09 + 6 mois → anniversaire 01/03 → échéance 28/02 23:59:59.
// Cas particulier du PLAFONNEMENT de fin de mois : dayjs.add(n,'month') rabat le jour quand le mois
// cible est plus court (ex. 31/08 + 6 mois → 28/02, car le 31 février n'existe pas). L'anniversaire
// tombe alors DÉJÀ sur le dernier jour du mois : l'échéance est CE dernier jour à 23:59:59 (ne PAS
// retrancher un jour, sinon on perd un jour → 27/02 au lieu du 28/02 attendu).
export const calculerEcheance = (dateEffet, dureeMois) => {
    if (!dateEffet) return null;
    const effet = dayjs(dateEffet);
    const anniversaire = effet.add(dureeMois, "month");
    // Si le jour a été rabattu, l'anniversaire est déjà en fin de mois → on le garde tel quel.
    if (anniversaire.date() !== effet.date()) {
        return anniversaire.endOf("day");
    }
    return anniversaire.subtract(1, "day").endOf("day");
}

export const isAfterToday = (dateStr) => {
    const givenDate = new Date(dateStr);

    // today at midnight
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return givenDate > today;
}

// Vrai tant que la date du jour ne dépasse pas (dateStr + `days` jours).
// Reste vrai avant l'échéance ET pendant la grâce de `days` jours après.
// Utilisé pour autoriser la prorogation jusqu'à 30 jours après l'échéance.
export const isWithinDaysAfter = (dateStr, days) => {
    if (!dateStr) return false;
    const limit = new Date(dateStr);
    limit.setDate(limit.getDate() + days);
    limit.setHours(23, 59, 59, 999); // fin du dernier jour autorisé
    return new Date() <= limit;
}

export const months = [
    { value: 1, label: 'Janvier' },
    { value: 2, label: 'Février' },
    { value: 3, label: 'Mars' },
    { value: 4, label: 'Avril' },
    { value: 5, label: 'Mai' },
    { value: 6, label: 'Juin' },
    { value: 7, label: 'Juillet' },
    { value: 8, label: 'Août' },
    { value: 9, label: 'Septembre' },
    { value: 10, label: 'Octobre' },
    { value: 11, label: 'Novembre' },
    { value: 12, label: 'Décembre' }
];